import axios from 'axios';
import GLightbox from 'glightbox';

export default function() {
  const lightbox = GLightbox({selector: '[data-glightbox-knit]', touchNavigation: false, draggable: false});

  if (!lightbox) return;

  lightbox.on('slide_after_load', (data) => {
    const { slideNode } = data;

    const knitSampleForm = slideNode.querySelector('#knit-sample-form');
    const knitSampleFormButton = slideNode.querySelector('#knit-sample-form button[type="submit"]');
    const knitSampleFormSuccess = slideNode.querySelector('#knit-sample-form-success');

    knitSampleForm.addEventListener("submit", (event) => {
      event.preventDefault();
      knitSampleFormButton.setAttribute('disabled', 'disabled');
      knitSampleFormButton.classList.add('opacity-50');
      axios({
        url: '',
        method: 'post',
        data: new FormData(knitSampleForm),
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          if (response.status === 200) {
            knitSampleForm.classList.add('hidden');
            knitSampleFormSuccess.classList.remove('hidden');
          }
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
    });
  });
}
